document.addEventListener('DOMContentLoaded', function () {
  var DEBUG = true;

  function log() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, arguments);
    } catch (e) {}
  }

  function warn() {
    if (!DEBUG) return;
    try {
      console.warn.apply(console, arguments);
    } catch (e) {}
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function waitForThemeSettings(done, reason) {
    var start = Date.now();
    var maxMs = 2000;
    var intervalMs = 50;

    (function tick() {
      if (window.themeSettings) {
        log('[MPS] themeSettings ready', { reason: reason, waitedMs: Date.now() - start });
        done(true);
        return;
      }
      if (Date.now() - start >= maxMs) {
        warn('[MPS] themeSettings STILL missing after wait', { reason: reason, waitedMs: Date.now() - start });
        done(false);
        return;
      }
      setTimeout(tick, intervalMs);
    })();
  }

  function fetchCartData(callback, reason) {
    var url = '/cart.js?t=' + Date.now();
    log('[MPS] fetchCartData()', { reason: reason || 'unknown', url: url });

    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        try {
          var cart = JSON.parse(xhr.responseText);
          callback(cart);
        } catch (e) {
          warn('[MPS] cart.js parse error', e);
        }
      }
    };
    xhr.send();
  }

  // Returns the HTML string for the message based on cart + settings
  function buildFreeShippingMessageHtml(cart) {
    if (!cart) return '';

    var s = window.themeSettings || {};
    var enabled = !!s.enableFreeShippingThreshold;
    var freeShippingThreshold = Number(s.freeShippingThreshold) || 0;
    var belowThresholdMessage = s.belowThresholdMessage || '';
    var aboveThresholdMessage = s.aboveThresholdMessage || '';

    var cartTotal = Number(cart.total_price) || 0;
    var thresholdCents = Math.round(freeShippingThreshold * 100);

    // NOTE: We escape settings messages to avoid breaking markup if someone enters < or &
    if (!enabled) {
      return `<p class="mps--top-bar-shipping-message">
        <a href="/pages/shipping-returns">${escapeHtml(belowThresholdMessage)}</a>
      </p>`;
    }

    if (cartTotal === 0) {
      return `<p class="mps--top-bar-shipping-message">
        <a href="/pages/shipping-returns">${escapeHtml(belowThresholdMessage)}</a>
      </p>`;
    }

    if (cartTotal >= thresholdCents) {
      return `<p class="mps--top-bar-shipping-message">
        <a href="/pages/shipping-returns">${escapeHtml(aboveThresholdMessage)}</a>
      </p>`;
    }

    var remaining = (thresholdCents - cartTotal) / 100;

    // IMPORTANT:
    // Do NOT reference topBarEl/drawerEl/cartPageEl here; they are scoped inside updateAllFreeShippingMessages().
    // Referencing them here causes a ReferenceError in the below-threshold branch, preventing updates.
    log('[MPS] below-threshold', { cartTotal: cartTotal, thresholdCents: thresholdCents, remaining: remaining });

    return `<p class="mps--top-bar-shipping-message">
      <a href="/pages/shipping-returns" style="margin: 0;">
        Add $${remaining.toFixed(2)} to your cart to unlock FREE shipping!
      </a>
    </p>`;
  }

  function applyMessageToContainer(container, html) {
    if (!container) return;

    // If the container is a <p>, injecting a <p> inside is invalid.
    // Your drawer snippet sometimes uses <p id="..."> in the else branch.
    // So if container is <p>, inject ONLY the inner <a> content or replace the <p> entirely.
    if (container.tagName === 'P') {
      // Extract the <a>...</a> from our html and put it inside the existing <p>
      var match = html.match(/<a\b[^>]*>[\s\S]*<\/a>/i);
      if (match) {
        container.innerHTML = match[0];
      } else {
        container.innerHTML = html;
      }
      return;
    }

    container.innerHTML = html;
  }

  function updateAllFreeShippingMessages(cart) {
    if (!cart) return;

    var topBarEl = document.getElementById('mps--top-bar-shipping-message-container');
    var drawerEl = document.getElementById('mps--cart-drawer-shipping-message-container');
    var cartPageEl = document.getElementById('mps--cart-page-shipping-message-container');

    log('[MPS] containers', {
      topBar: !!topBarEl,
      drawer: !!drawerEl,
      cartPage: !!cartPageEl
    });

    var html = buildFreeShippingMessageHtml(cart);
    if (!html) return;

    applyMessageToContainer(topBarEl, html);
    applyMessageToContainer(drawerEl, html);
    applyMessageToContainer(cartPageEl, html);
  }

  function refreshFreeShippingMessage(cartMaybe, reason) {
    if (cartMaybe && typeof cartMaybe.total_price !== 'undefined') {
      updateAllFreeShippingMessages(cartMaybe);
      return;
    }
    fetchCartData(
      function (cart) {
        updateAllFreeShippingMessages(cart);
      },
      reason || 'refresh'
    );
  }

  function refreshBurst(reason) {
    refreshFreeShippingMessage(null, (reason || 'unknown') + ':0ms');
    setTimeout(function () {
      refreshFreeShippingMessage(null, (reason || 'unknown') + ':250ms');
    }, 250);
    setTimeout(function () {
      refreshFreeShippingMessage(null, (reason || 'unknown') + ':800ms');
    }, 800);
    setTimeout(function () {
      refreshFreeShippingMessage(null, (reason || 'unknown') + ':1500ms');
    }, 1500);
  }

  waitForThemeSettings(
    function (ok) {
      if (!ok) return;

      // === Symmetry hooks ===
      document.addEventListener(
        'on:cart:after-merge',
        function () {
          refreshBurst('event:on:cart:after-merge');
        },
        true
      );

      document.addEventListener(
        'on:cart:add',
        function () {
          refreshBurst('event:on:cart:add');
        },
        true
      );

      document.addEventListener(
        'on:cart:error',
        function () {
          refreshBurst('event:on:cart:error');
        },
        true
      );

      // IMPORTANT: drawer content may not exist until it opens
      document.addEventListener(
        'on:cart-drawer:after-open',
        function () {
          refreshBurst('event:on:cart-drawer:after-open');
        },
        true
      );

      // Initial render (top bar will update; drawer will update once it exists)
      refreshBurst('initial');
    },
    'boot'
  );
});